import main from '@/views/main.vue'

export const loginRouter = {
  path: '/login',
  name: 'login',
  meta: {
    title: 'Login - 登录'
  },
  component: () => import('@/views/login.vue')
};

export const bookReadRouter = {
  path: '/bookread',
  name: 'bookread',
  meta: {
      title: '阅读'
  },
  component: () => import('@/views/bookread.vue')
};

export const otherRouter = {
  path: '',
  name: 'homeRouter',
  component: main,
  children: [
    {
      path: '/home',
      title: '首页',
      name: 'home_index',
      component: () => import('@/views/home/home.vue')
    }
  ],
  meta: {
    requiresAuth: true
  }
};

export const appRouter = [];

export const routers = [
  loginRouter,
  bookReadRouter,
  otherRouter,
  ...appRouter
];

